<div *ngIf="!hideDescription || errorMessages.length || property.deprecated" class="wrapper">
  <mat-hint class="{{additionalClass}}">
    <span *ngIf="property.description && !hideDescription" class="info">
      <ng-container *ngIf="translationPrefix">{{translationPrefix + '.' + keyName | translate}}</ng-container>
      <ng-container *ngIf="!translationPrefix">{{property.description}}</ng-container>
    </span>
    <span *ngIf="property.deprecated" class="warn"><mat-icon color="warn">warning</mat-icon>
      {{property.deprecated}}</span>
    <span *ngFor="let errorMessage of errorMessages" class="error"><mat-icon>error</mat-icon>
      {{errorMessage.message}}</span>
  </mat-hint>
</div>

